import { render, staticRenderFns } from "./QAgentAccountsAdminSubmenu.vue?vue&type=template&id=8805e05e&"
import script from "./QAgentAccountsAdminSubmenu.vue?vue&type=script&lang=js&"
export * from "./QAgentAccountsAdminSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports